"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Container = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const styled_bootstrap_grid_1 = require("styled-bootstrap-grid");
exports.Container = (0, styled_components_1.default)(styled_bootstrap_grid_1.Container) `
  box-sizing: border-box;

  @media (min-width: ${props => props.theme.breakpoints.sm}px) {
    max-width: ${props => props.theme.constants.bootstrapContainer.sm}px;
  }

  @media (min-width: ${props => props.theme.breakpoints.md}px) {
    max-width: ${props => (props === null || props === void 0 ? void 0 : props.isWarrantyBlock)
    ? props.theme.constants.warrantyPage.warrantyMaxWidth
    : props.theme.constants.bootstrapContainer.md}px;
  }

  @media (min-width: ${props => props.theme.breakpoints.lg}px) {
    max-width: ${props => (props === null || props === void 0 ? void 0 : props.isWarrantyBlock)
    ? props.theme.constants.warrantyPage.warrantyMaxWidth
    : props.theme.constants.bootstrapContainer.lg}px;
  }

  @media (min-width: ${props => props.theme.breakpoints.xl}px) {
    max-width: ${props => (props === null || props === void 0 ? void 0 : props.isWarrantyBlock)
    ? props.theme.constants.warrantyPage.warrantyMaxWidth
    : props.theme.constants.bootstrapContainer.lg}px;
  }

  @media (min-width: ${props => props.theme.breakpoints.xxl}px) {
    max-width: ${props => (props === null || props === void 0 ? void 0 : props.isWarrantyBlock)
    ? props.theme.constants.warrantyPage.warrantyMaxWidth
    : props.theme.constants.bootstrapContainer.xl}px;
  }

  @media (min-width: ${props => props.theme.breakpoints.xxxl}px) {
    max-width: ${props => (props === null || props === void 0 ? void 0 : props.isWarrantyBlock)
    ? props.theme.constants.warrantyPage.warrantyMaxWidth
    : props.theme.constants.bootstrapContainer.xxl}px;
  }
`;
exports.default = {
    Container: exports.Container
};
